/**
 * package: com.inq.flash.client.data
 * class: ChatAutomatonDataMessage
 * @extends com.inq.flash.messagingframework.Message
 * @constructor
 *
 * @param {com.inq.flash.client.data.Chat} chat - instance of the chat
 * @param {string} text - the text of the message
 */
com.inq.flash.client.data.ChatAutomatonDataMessage = function(chat, text) {
	com.inq.flash.messagingframework.Message.call(this);
	this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_DATA);
	this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_CHAT_ID, chat.getChatID());
	this.addPropertyIfNotNull(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA, text);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_RETURN_RECEIPT,"1");
};
$hxClasses.extend(com.inq.flash.messagingframework.Message,
	com.inq.flash.client.data.ChatAutomatonDataMessage,
	"com.inq.flash.client.data.ChatAutomatonDataMessage"
);
